interface ExternalNavigateProps {
  to: string;
}
export const ExternalNavigate = ({ to }: ExternalNavigateProps): null => {
  window.location.href = to;
  return null;
};
